import { render, staticRenderFns } from "./WhiteLabelPubColors.vue?vue&type=template&id=7b6501ae"
import script from "./WhiteLabelPubColors.vue?vue&type=script&lang=js"
export * from "./WhiteLabelPubColors.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelPubColors.vue?vue&type=style&index=0&id=7b6501ae&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports